export default "__VITE_ASSET__CUVUKYJY__"